import { render, staticRenderFns } from "./SatelliteDomains.vue?vue&type=template&id=500fa67a&scoped=true"
import script from "./SatelliteDomains.vue?vue&type=script&lang=js"
export * from "./SatelliteDomains.vue?vue&type=script&lang=js"
import style0 from "./SatelliteDomains.vue?vue&type=style&index=0&id=500fa67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500fa67a",
  null
  
)

export default component.exports